var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-block d-flex",on:{"click":_vm.pageToVideo}},[_vm._m(0),_vm._m(1),_vm._m(2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-each"},[_c('img',{attrs:{"src":require("../../../assets/img/vedio01.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-each"},[_c('img',{attrs:{"src":require("../../../assets/img/more.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-each"},[_c('img',{attrs:{"src":require("../../../assets/img/vedio02.png")}})])
}]

export { render, staticRenderFns }